import styled from '@emotion/styled';
import CreditInformationLogo from '@assets/icons/CreditInformation.svg';
import DPOLogo from '@assets/icons/DPO.svg';
import AMLCLogo from '@assets/icons/AMLC.svg';
import SecuritiesExchangeLogo from '@assets/icons/SecuritiesExchange.svg';
import { Link } from 'react-router-dom';

const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	gap: 20px;
	padding: 16px;
	border-radius: 12px;
	background: #f4f4f3;
	margin-top: 24px;
`;

const Title = styled.h3`
	text-align: left;
	width: 100%;
	overflow: hidden;
	color: rgba(27, 31, 59, 0.8);
	text-overflow: ellipsis;
	font-size: 20px;
	font-weight: 800;
	line-height: 24px;
	margin: 0;
`;

const IconContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
`;

const Icon = styled.img`
	position: relative;
	width: 100%;
	height: 100%;
	max-height: 54px;
`;

const Message = styled.p`
	color: rgba(27, 31, 59, 0.4);
	font-size: 11px;
	font-weight: 500;
	line-height: 16px;
	letter-spacing: 0.4px;
	text-decoration: none;
	margin: 0;
`;

const StyledLink = styled(Link)`
	text-decoration: underline;
	color: inherit;
`;

export enum LoanOnlineProducts {
	SALMON_CREDIT = 'SALMON_CREDIT',
	CASH_LOAN = 'CASH_LOAN',
	FINANCING = 'FINANCING',
}

export interface RegulatedByProps {
	productType: LoanOnlineProducts;
}

export default function RegulatedBy(props: RegulatedByProps) {
	const privacyPolicyLink =
		'https://s.slmn.ph/App_User-Sunprime-General-Terms-and-Conditions.pdf';
	const SECRegulatorLink =
		'https://s.slmn.ph/docs/Sunprime_Finance_Inc_Certificate_of_Incorporation_and_Authority_to_Operate_as_a_Financing_Company.pdf';

	const regulatedByIcons: string[] = [
		SecuritiesExchangeLogo,
		DPOLogo,
		CreditInformationLogo,
		AMLCLogo,
	];

	const disclamersByOroductType: Record<
		LoanOnlineProducts,
		{ message: React.ReactNode }
	> = {
		[LoanOnlineProducts.SALMON_CREDIT]: {
			message: (
				<Message>
					LoanOnline and Salmon Credit are provided by Sunprime Finance Inc.,{' '}
					<StyledLink target="_blank" to={SECRegulatorLink}>
						SEC Reg. No. CS201916698, C.A. No. 1241
					</StyledLink>
					. Make sure to read and understand our{' '}
					<StyledLink target="_blank" to={privacyPolicyLink}>
						Terms & Conditions
					</StyledLink>
				</Message>
			),
		},
		[LoanOnlineProducts.CASH_LOAN]: {
			message: (
				<Message>
					LoanOnline and Cash Loan are provided by Sunprime Finance Inc.,{' '}
					<StyledLink target="_blank" to={SECRegulatorLink}>
						SEC Reg. No. CS201916698, C.A. No. 1241
					</StyledLink>
					. Make sure to read and understand our{' '}
					<StyledLink target="_blank" to={privacyPolicyLink}>
						Terms & Conditions
					</StyledLink>
				</Message>
			),
		},
		[LoanOnlineProducts.FINANCING]: {
			message: (
				<Message>
					LoanOnline and Financing is provided by Sunprime Finance Inc.,{' '}
					<StyledLink target="_blank" to={SECRegulatorLink}>
						SEC Reg. No. CS201916698, C.A. No. 1241
					</StyledLink>
					. Make sure to read and understand our{' '}
					<StyledLink target="_blank" to={privacyPolicyLink}>
						Terms & Conditions
					</StyledLink>
				</Message>
			),
		},
	};

	const { productType } = props;
	const { message } = disclamersByOroductType[productType];

	return (
		<Container>
			<Title>Regulated by</Title>
			<IconContainer>
				{regulatedByIcons.map((icon, index) => (
					<Icon src={icon} alt="Regulated by" key={index} />
				))}
			</IconContainer>
			{message}
		</Container>
	);
}
